/**
 * @flow
 * @relayHash 8fdbf97d5641431219ffff430e2baeed
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type HomeAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query HomeAdminQuery {
  admin {
    ...Home_admin
  }
}

fragment Home_admin on Admin {
  ...Metrics_admin
}

fragment Metrics_admin on Admin {
  metrics {
    timeBased {
      ...TimeBasedChart_timeBased
    }
    ...Activity_metrics
  }
}

fragment TimeBasedChart_timeBased on TimeBasedMetric {
  jobRequests {
    ...TimeBasedChartFragment
  }
  jobOffers {
    ...TimeBasedChartFragment
  }
  jobs {
    ...TimeBasedChartFragment
  }
  students {
    ...TimeBasedChartFragment
  }
  tutors {
    ...TimeBasedChartFragment
  }
  expiredJobRequestsWithNoOffers {
    ...TimeBasedChartFragment
  }
  expiredJobRequestsWithOffers {
    ...TimeBasedChartFragment
  }
}

fragment Activity_metrics on Metrics {
  openJobOffers
  openJobRequestsWithNoOffers
  openJobRequests
  startedJobs
  pendingTutors
}

fragment TimeBasedChartFragment on MetricTimePeriod {
  today
  yesterday
  pastWeek
  pastMonth
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Home_admin",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "HomeAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "HomeAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Metrics",
            "name": "metrics",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "TimeBasedMetric",
                "name": "timeBased",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "jobRequests",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "jobOffers",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "jobs",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "students",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "tutors",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "expiredJobRequestsWithNoOffers",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricTimePeriod",
                    "name": "expiredJobRequestsWithOffers",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "today",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "yesterday",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastWeek",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "pastMonth",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "type": "Metrics",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "openJobOffers",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "openJobRequestsWithNoOffers",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "openJobRequests",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "startedJobs",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "pendingTutors",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query HomeAdminQuery {\n  admin {\n    ...Home_admin\n  }\n}\n\nfragment Home_admin on Admin {\n  ...Metrics_admin\n}\n\nfragment Metrics_admin on Admin {\n  metrics {\n    timeBased {\n      ...TimeBasedChart_timeBased\n    }\n    ...Activity_metrics\n  }\n}\n\nfragment TimeBasedChart_timeBased on TimeBasedMetric {\n  jobRequests {\n    ...TimeBasedChartFragment\n  }\n  jobOffers {\n    ...TimeBasedChartFragment\n  }\n  jobs {\n    ...TimeBasedChartFragment\n  }\n  students {\n    ...TimeBasedChartFragment\n  }\n  tutors {\n    ...TimeBasedChartFragment\n  }\n  expiredJobRequestsWithNoOffers {\n    ...TimeBasedChartFragment\n  }\n  expiredJobRequestsWithOffers {\n    ...TimeBasedChartFragment\n  }\n}\n\nfragment Activity_metrics on Metrics {\n  openJobOffers\n  openJobRequestsWithNoOffers\n  openJobRequests\n  startedJobs\n  pendingTutors\n}\n\nfragment TimeBasedChartFragment on MetricTimePeriod {\n  today\n  yesterday\n  pastWeek\n  pastMonth\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/home/__generated__/HomeAdminQuery.graphql.js